<template>
  <div>
    <shareHead></shareHead>
    <div class="offset"></div>
    <personalDetail :isSharePage="true" :isShowBack="false" :personJoinInfo="personJoinInfo" :title="getTitle">
      <div slot="foot" style="width: 100%">
        <!--    投票数-->
        <div v-if="isVote1Page" class="voteCount dw">{{getVote1Count}} 票</div>
        <div v-if="isVote2Page" class="voteCount dw">{{getVote2Count}} 票(决赛)</div>
        <!--    脚部-->
        <div class="foot dw">
          <div class="main" @click="homePage">主页</div>
          <div v-if="isVote1Page" class="voteIcon" @click="vote">投票</div>
          <div v-else-if="isVote2Page" class="voteIcon" @click="vote">投票</div>
          <div v-else class="mid_null"></div>
          <div class="share" @click="sharePage">分享</div>
        </div>
      </div>
    </personalDetail>

    <van-dialog v-model="dialogShow" title="长按图片关注公众号进行投票" :show-confirm-button="false" :close-on-click-overlay="true">
<!--      <img src="https://img01.yzcdn.cn/vant/apple-3.jpg" />-->
      <div style="height: 1.5rem"></div>
      <div class="qrcode_dialog">
        <vue-qr :text="qrcodeUrl" :logoSrc="require('../../../assets/app/logo.png')" :size="400"></vue-qr>
      </div>
      <div style="height: 1rem"></div>
    </van-dialog>
  </div>
</template>

<script>
import {actUtil} from "../../../js/activity/util";
import {ImagePreview, Toast, Dialog} from "vant";
import {activity} from "../../../js/activity/getInfo";
import personalDetail from "../item/personalDetail";
import shareHead from "./shareHead";
import {actConfig} from "../../../js/activity/actConfig";
import {userVote1, userVote2} from "../../../js/activity/vote";
import {shareGetQrcode, shareWXInit} from "../../../js/activity/share";
import VueQr from "vue-qr";
import {baseConfig} from "../../../network/baseConfig";
import {wxAccountMgr} from "../../../network/wx/wxAccountMgr";
import {errDailog} from "../../../js/activity/errDialog";
import homeRecommend from "../../ recommend/homeRecommend";
import {apiSys} from "../../../network/app/sys";

const wxRetState = 'ie8dflfLfiwq'
export default {
  name: "sharePersonalDetail",
  components:{
    homeRecommend,
    personalDetail,
    shareHead,
    VueQr,
    [Dialog.Component.name]: Dialog.Component,
  },
  data(){
    return {
      dialogShow: false,
      actID: 0,
      userId: '',
      page: '',
      personJoinInfo: {},
      qrcodeUrl: "http://weixin.qq.com/q/02lkNew2swd911zwEkNycZ",
    }
  },
  computed:{
    getBanJi(){
      return actUtil.toGradeString(this.personJoinInfo.grade)
    },
    getAge(){
      return actUtil.toAge(this.personJoinInfo.birthday)
    },
    getVote1Count(){
      return this.personJoinInfo.voteNum1
    },
    getVote2Count(){
      return this.personJoinInfo.voteNum2
    },
    isVote1Page(){
      return this.page=='vote1'
    },
    isVote2Page(){
      return this.page=='vote2'
    },
    getTitle(){
      return actConfig.getData()
    }
  },
  created() {
    document.documentElement.scrollTop = 0;
    // console.log('shareActPersonPage create');
    //输入的参数
    // console.log(this.$route.params)
    // console.log(this.$route.query)

    this.userId = this.$route.params.userId
    this.page = this.$route.params.page
    this.actID = this.$route.params.actID
    //页面查询错误提示
    if(!(this.page=='vote1'
        || this.page=='vote2'
        || this.page=='final')){
      this.$myDialog({
        logo: 'fail',
        text: '404 not find page!',
        btnOK: "确认",
        callBack: (state) => { }
      });
      return
    }

    Toast.loading({
      duration: 5000, // 持续展示 toast
      forbidClick: true,
      message: '加载中...',
    });

    //获取活动详情
    actConfig.getData().activityId = this.actID
    this.getDetail()
  },
  mounted() {
    // console.log('share home mount');
    // (window.slotbydup = window.slotbydup || []).push({
    //   id: "u6789907",
    //   container: "_wdkrq3k2km",
    //   async: true
    // });
  },
  methods:{
    //阻止关闭弹框
    onBeforeClose(action, done) {
      if (action === "confirm") {//点击确定按钮
        return done(false);//阻止关闭
      } else {
        return done()//允许关闭
      }
    },
    changeMemberName () {

    },
    getDetail(){
      // 获取活动详情--无需token
      activity.getActDetail().then(baseInfo=>{
        console.log(baseInfo.title);
        actConfig.getData().activityTitle = baseInfo.title
        actConfig.getData().activityLogo = baseInfo.img

        //查询用户信息
        this.getCansaiVideo(this.userId)
      }).catch(err=>{
        Toast.clear()
        errDailog(this, err.code, this.getDetail)
        // this.$myDialog({
        //   logo: 'fail',
        //   text: err.msg,
        //   btnOK: "重试",
        //   btnCancel: "取消",
        //   callBack: (state)=>{
        //     console.log('获取活动详情 callback='+state)
        //     if(state){
        //       this.getDetail()
        //     }
        //   }
        // });
      }).finally(()=>{})
    },
    getCansaiVideo(userId) {
      // console.log('开始获取用户参赛视频');
      let obj = {
        userId: userId,    //搜索关键字  (string)
        shortlisted: 0,    //是否入围50名 0:不限 1:入围
      }
      //获取前50名
      activity.getCansaiVideo(obj).then(joinList => {
        // console.log('获取用户参赛视频 ok');
        // console.log(joinList.joins.length)
        if(joinList.joins.length==0){
          this.tipRetry(userId,'查不到询用户信息！')
        }else{
          this.personJoinInfo = joinList.joins[0]
        }

        {
          shareWXInit(actConfig.getData().activityTitle,
              // '我是'+this.personJoinInfo.fullName+'，请投我一票！',
              "大家好！我是"+this.personJoinInfo.fullName+"，我正在参加〝"+ actConfig.getData().activityTitle +"〞。请投我一票！",
              window.location.href,
              this.personJoinInfo.userImg)
        }

        // console.log('*********************************shareGetQrcode');
        let actId = actConfig.getData().activityId
        let title = actConfig.getData().activityTitle
        let describe = "大家好！我是"+this.personJoinInfo.fullName+"，我正在参加”"+ actConfig.getData().activityTitle +"“。请投我一票！"
        let picUrl = this.personJoinInfo.userImg
        let linkUrl = baseConfig.makeShareUrl('share/shareMPActPersonPage/'
                                                          +this.page+'/'
                                                          +actConfig.getData().activityId+'/'
                                                          +userId)

        wxAccountMgr.getQrcode(actId, userId, title, describe, picUrl, linkUrl).then(res=>{
          // console.log(res)
          this.qrcodeUrl = res.qrcodeURL
          // console.log(this.qrcodeUrl)
        }).catch(err => {
        })

        Toast.clear()
      }).catch(err => {
        Toast.clear()
        console.log('获取用户参赛视频 err' + err);
        if (err.code!=10005){
          this.tipRetry(userId,err.msg)
        }

      })
    },
    tipRetry(userId, msg){
      var that = this
      this.$myDialog({
        logo: 'fail',
        text: msg,
        btnOK: "重试",
        btnCancel: "取消",
        callBack: (state) => {
          console.log('获取用户参赛视频 callback=' + state)
          if(state){
            that.getCansaiVideo(userId)
          }
        }
      });
    },
    homePage(){
      // this.$route.params.isVote = this.isVote
      // this.$router.back()
      // this.$router.replace({name:'shareHome'})
      this.$router.replace({path: '/share/shareHome/'+actConfig.getData().activityId})
    },
    vote(){
      this.dialogShow = true
      return;

      if(this.$parent.checkWXAuth())
      {
        if(this.isVote1Page){
          userVote1(this, this.personJoinInfo)
        }else if(this.isVote2Page){
          userVote2(this, this.personJoinInfo)
        }
      }
    },
    sharePage(){
      this.$myDialog({
        logo: 'null',
        text: "请点击右上角“...”进行分享。",
        btnOK: "确认",
        callBack: (state) => { }
      });
    }
  }
}
</script>

<style scoped>

.qrcode_dialog{
  margin: auto;
  width: 900px;
  height: 900px;
  /*background-color: black;*/
}
.qrcode_text{
  margin: auto;
  /*padding-top: 20px;*/
  line-height: 100px;
  width: 100%;
  height: 140px;
  text-align: center;
  color: white;
  font-size: 40px;
  /*background-color: #ff5777;*/
}

.offset{
  width: 100%;
  height: 120px;
  /*background-color: #ff8198;*/
}
.dw{
  width: 990px;
  margin: auto;
}
.voteCount{
  margin-bottom: 30px;
  font-size: 50px;
  line-height: 70px;
  color: #3c3d41;
  text-align: center;
  /*background-color: #ee0a24;*/
}
.foot{
  position: relative;
  height: 180px;
  width: 690px;
  /*background-color: #ff5777;*/
}
.main,
.mid_null,
.share,
.voteIcon
{
  float: left;
  width: 230px;
  height: 170px;
  /*background-color: #fed554;*/
  font-size: 40px;
  text-align: center;
  line-height: 250px;
  color: #3c3d41;
  font-weight: normal;
  /*background-size: 50% 50%;*/
  background-repeat: no-repeat;
  background-position: top center;
}
.main{
  background-image: url("../../../assets/act001/home.png");
  background-size: 60px 69px;
}
.share{
  background-image: url("../../../assets/act001/share.png");
  background-size: 95px 70px;
}
.voteIcon{
  /*background-image: url("../../../assets/act001/btnVote.png");*/
  /*background-size: 160px 160px;*/
  background-color: #2b80ed;
  border-radius: 170px;
  width: 170px;
  margin-left: 30px;
  line-height: 170px;
  color: whitesmoke;
  font-weight: bolder;
}

</style>

